var link_viewer_default = {
  "fontElementMap": "UomY0",
  "link": "i9WLr",
  "linkInEditor": "Dm3ml",
  "linkInViewer": "CmCxT",
  "toolbarUrlContainer": "cEfm2",
  "toolbarUrl": "ZN-sc",
  "toolbarUrlAnchor": "mkQkb"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
